import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid'
import { Input } from '@nextui-org/react'
import { useState } from 'react'
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form'

import type { ControlledInputProps } from './type'

export function PasswordInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  fieldProps,
  name,
  rules,
}: Readonly<ControlledInputProps<TFieldValues, TName>>) {
  const [isVisible, setIsVisible] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error, invalid },
      }) => (
        <Input
          classNames={{
            label: 'uppercase',
          }}
          endContent={
            <button
              className="absolute right-4 top-1/2 w-6 -translate-y-1/2 transform focus:outline-none"
              onClick={toggleVisibility}
              type="button"
            >
              {isVisible ? (
                <EyeSlashIcon className="pointer-events-none text-2xl text-default-400" />
              ) : (
                <EyeIcon className="pointer-events-none text-2xl text-default-400" />
              )}
            </button>
          }
          errorMessage={error?.message}
          isInvalid={invalid}
          isRequired={rules?.required as boolean}
          onBlur={onBlur}
          onChange={onChange}
          type={isVisible ? 'text' : 'password'}
          value={value}
          {...fieldProps}
        />
      )}
      rules={rules}
    />
  )
}

export default PasswordInput
